/*
 * @Description: Vuex入口
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: hai-27
 * @LastEditTime: 2020-02-25 22:51:50
 */
import Vue from 'vue'
import Vuex from 'vuex'

import goods from './modules/goods'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  modules: {
    goods
  }
})
